export enum UploadFileStatus {
  ERROR = 'setErrorState',
  COMPLETE = 'setUploadedState',
  UPLOADING = 'setUploadingState',
}
